import type { TelaComAbasProps } from "./types-tela-com-abas";
import { TelaComAbasView } from "./view-tela-com-abas";

/** Casca de tela com título e abas por rota (`PageHeader` do DS) sobre o cartão branco; o corpo vem em `children`. */
export function TelaComAbas({ variante = "livre", ...props }: TelaComAbasProps) {
  return (
    <TelaComAbasView
      {...props}
      variante={variante}
      fullBleed={variante === "janela" ? true : undefined}
    />
  );
}

export type * from "./types-tela-com-abas";
